import React from 'react'
import { RobotOutlined, ThunderboltOutlined, UserOutlined } from '@ant-design/icons'

export const ActorTypes = {
    CSV: -1,
    ML_CREATED: -2,
    USER_OF_ORIGINAL_MODEL: -3,
    LLM: -4,
    MERGED_DECISION: -5,
    SENSE_ASSISTANT: -6,
}

export const NonHumanActors = [ActorTypes.ML_CREATED, ActorTypes.LLM, ActorTypes.MERGED_DECISION]

export const getActorName = actor => {
    if (actor?.name) return actor.name
    if (actor === ActorTypes.CSV) return 'CSV Creator'
    if (actor === ActorTypes.ML_CREATED) return 'AI'
    if (actor === ActorTypes.USER_OF_ORIGINAL_MODEL) return 'User of Original Model'
    if (actor === ActorTypes.LLM) return 'Sense Semantics'
    if (actor === ActorTypes.MERGED_DECISION) return 'Merged Decision'
    if (actor === ActorTypes.SENSE_ASSISTANT) return 'Sense Assistant'
    return 'Unknown User'
}

export const getActorIcon = actor => {
    if (actor === ActorTypes.CSV) return <UserOutlined />
    if (actor === ActorTypes.ML_CREATED) return <RobotOutlined />
    if (actor === ActorTypes.USER_OF_ORIGINAL_MODEL) return <UserOutlined />
    if (actor === ActorTypes.LLM) return <ThunderboltOutlined />
    if (actor === ActorTypes.MERGED_DECISION) return <ThunderboltOutlined />
    if (actor === ActorTypes.SENSE_ASSISTANT) return <ThunderboltOutlined />
    return undefined
}
